import { z } from 'zod';

export const TagSchema = z.object({
  id: z.string(),
  label: z.string(),
  user: z.nullable(z.string()),
});

export type ITag = z.infer<typeof TagSchema>;

export const TagInDatabaseSchema = z.object({
  label: z.string(),
  user: z.string(),
});

export type TagInDatabase = z.infer<typeof TagInDatabaseSchema>;
